var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoOfferIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "no-offer-icon",
    transform: "translate(3193 -847)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33290",
    "data-name": "Group 33290",
    transform: "translate(-3191.557 859.986)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "no-offer",
    transform: "translate(30.661 9.259)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43731",
    "data-name": "Path 43731",
    d: "M17.166,35.724a2.751,2.751,0,0,1-1.362-.379L15.72,35.3.485,20.252l-.05-.092a2.551,2.551,0,0,1,.5-3.413L17.3,0,29.43.189l-.023,1.443L17.9,1.449,1.9,17.82a1.1,1.1,0,0,0-.245,1.556l14.94,14.755a1.14,1.14,0,0,0,1.13.005L33.97,17.35,33.618,4.928l1.442-.041.369,13.03L18.612,35.291l-.088.051A2.707,2.707,0,0,1,17.166,35.724Z",
    transform: "translate(-0.003 0.003)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43732",
    "data-name": "Path 43732",
    d: "M26.565,12.628,26.386,11.2c2.35-.292,3.359-2.9,3.486-3.259a9.363,9.363,0,0,0,.11-2.334A5.594,5.594,0,0,0,26.669,2.57a6.589,6.589,0,0,0-2.547-.076L20.063,5.954l-.936-1.1,4.329-3.691.169-.04A7.719,7.719,0,0,1,27,1.164l.036.007.035.011a7,7,0,0,1,4.27,3.907l.057.118.012.13a10.79,10.79,0,0,1-.123,2.907l-.008.047-.014.045C31.211,8.493,30,12.2,26.565,12.628Z",
    transform: "translate(8.466 0.429)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Line_2",
    "data-name": "Line 2",
    d: "M15.871.943H0V-.5H15.871Z",
    transform: "translate(36.431 13.918)",
    fill: "#9f9c9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_3",
    "data-name": "Line 3",
    d: "M5.771.943H0V-.5H5.771Z",
    transform: "translate(26.331 13.918)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_5",
    "data-name": "Line 5",
    d: "M5.771.943H0V-.5H5.771Z",
    transform: "translate(15.51 13.918)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43734",
    "data-name": "Path 43734",
    d: "M4.289-2.821H6.578v1.655H4.289V1.421H2.546V-1.166H.25V-2.821h2.3V-5.3H4.289Z",
    transform: "translate(-0.25 22.614)",
    fill: "#545c5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43735",
    "data-name": "Path 43735",
    d: "M4.289-2.821H6.578v1.655H4.289V1.421H2.546V-1.166H.25V-2.821h2.3V-5.3H4.289Z",
    transform: "translate(32.935 51.471)",
    fill: "#9f9c9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43736",
    "data-name": "Path 43736",
    d: "M4.289-2.821H6.578v1.655H4.289V1.421H2.546V-1.166H.25V-2.821h2.3V-5.3H4.289Z",
    transform: "translate(67.564 5.3)",
    fill: "#545c5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43737",
    "data-name": "Path 43737",
    d: "M3.186-2.026h2v.863h-2V1.105H2.269V-1.163h-2v-.863h2v-2.1h.917Z",
    transform: "translate(18.514 39.007)",
    fill: "#545c5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43738",
    "data-name": "Path 43738",
    d: "M3.186-2.026h2v.863h-2V1.105H2.269V-1.163h-2v-.863h2v-2.1h.917Z",
    transform: "translate(64.685 39.007)",
    fill: "#545c5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_6",
    "data-name": "Line 6",
    d: "M15.871.943H0V-.5H15.871Z",
    transform: "translate(13.346 22.575)",
    fill: "#9f9c9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43739",
    "data-name": "Path 43739",
    d: "M1.443,0A1.443,1.443,0,1,1,0,1.443,1.443,1.443,0,0,1,1.443,0Z",
    transform: "translate(47.253 20.633)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43740",
    "data-name": "Path 43740",
    d: "M1.443,0A1.443,1.443,0,1,1,0,1.443,1.443,1.443,0,0,1,1.443,0Z",
    transform: "translate(53.024 24.961)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43733",
    "data-name": "Path 43733",
    d: "M-2184.118,739.244l-1.442-.034a4.588,4.588,0,0,0-2.267-4.091l-.008,0a9.256,9.256,0,0,0-3.71-1.173l.058-1.442a10.656,10.656,0,0,1,4.351,1.352A6.054,6.054,0,0,1-2184.118,739.244Z",
    transform: "translate(2234.977 -707.052)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43741",
    "data-name": "Path 43741",
    d: "M0,0H8.657V4.329H0Z",
    transform: "translate(55.983 12.384) rotate(47)",
    fill: "#f5e98c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_21634_-_Outline",
    "data-name": "Rectangle 21634 - Outline",
    d: "M1.443,1.443V2.886H7.214V1.443H1.443M0,0H8.657V4.329H0Z",
    transform: "translate(55.983 12.384) rotate(47)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21636",
    "data-name": "Rectangle 21636",
    width: 78,
    height: 78,
    transform: "translate(-3193 847)",
    fill: "#fff",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoOfferIcon);
export default __webpack_public_path__ + "static/media/no-offer-icon.3eecd90aeae09715300b18c54ee9e8bf.svg";
export { ForwardRef as ReactComponent };